import React from "react";
import { useSelector } from "react-redux";
import EditAttributeDialogComponent from './editAttributeDialog.component';
import {AccessRights} from "../../../../../lib/constants/accessRights";
import {canAccess} from "../../../../profile/redux/selector/profile.selector";

export default function EditAttributeDialogContainer({
  isOpen,
  handleClose,
  handleSubmit,
  data,
  isSaving,
}) {
  const lang = useSelector(state => state.constant.languages)
  const canEditOption = useSelector(state => canAccess(state, AccessRights.Product.ATTRIBUTE_UPDATE_OPTION))
  const canEditName = useSelector(state => canAccess(state, AccessRights.Product.ATTRIBUTE_UPDATE_NAME))
  const canEditStatus = useSelector(state => canAccess(state, AccessRights.Product.ATTRIBUTE_UPDATE_STATUS))

  return (
    <EditAttributeDialogComponent
      handleClose={handleClose}
      handleSubmit={handleSubmit}
      isOpen={isOpen}
      data={data}
      lang={lang}
      isSaving={isSaving}
      canEditOption={canEditOption}
      canEditName={canEditName}
      canEditStatus={canEditStatus}
    />
  )
}
